module.exports = __webpack_public_path__ + "public/media/bg_app_down_area.bb539de3.png";